// src/utils/userMeta.js

export const getUserIP = async () => {
  const res = await fetch("https://api.ipify.org?format=json");
  const data = await res.json();
  return data.ip;
};

export const getBrowserData = () => ({
  userAgent: navigator.userAgent,
  language: navigator.language,
  platform: navigator.platform,
  vendor: navigator.vendor,
});
